import React, {Fragment, useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {spinnerOff, spinnerOn} from "../../components/Spinner";
import {get, getDuplicateProjects, getProject, post, updateProject} from "../../api";
import {confirmAlert} from "react-confirm-alert";
import ViewType from "../../components/ViewType";
import ProjectsGrid from "../../components/ProjectsGrid";
import ProjectsList from "../../components/ProjectsList";
import MergeProject from "./ProjectMerge";
import Alert from "../../components/Alert";

export default withRouter(function Upcoming(props) {
    const {context, history, cardview, onViewTypeChange, projectList } = props;
    const {setActiveProject, setActiveDashboardTab} = context;
    const [projects, setProjects] = useState([]);
    const [refreshProjects, setRefreshProjects] = useState(true);
    const [isLoading, setIsLoading] = useState(false);     

    useEffect(() => {
        async function getProjects() {
            if ((projects && projects.length < 1) || refreshProjects) {
                spinnerOn();
                setIsLoading(true);
                let project = {};
                project.projectStatus = "U";
                const result = await post(`projects`, "", project);
                setProjects(result.projects);
                spinnerOff();
                setIsLoading(false);
            }
        }

        getProjects();
    }, [refreshProjects]);

    function invalidDataConfirm() {
        let msg = "This project was updated by other user, Reloading..";
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Alert msg={msg} onClose={onClose}/>
                );
            }
        });
    }

    //find out if any duplicate projects exists
    async function startProject(project) {
        context.setProjectTab('upcoming');
        //find duplicates
        const dupIds = await getDuplicateProjects(project.id, {});
        //if duplicates exist
        if (dupIds && dupIds.length > 1) {
            let dupProjects = getDupProjects(dupIds);
            mergeProjectConfirm(project, dupProjects, dupIds);
        } else { //if duplicates doesn't exist
            //show confirm yes or no
            startProjectConfirm(project);
        }
    }

    //no duplicates exist, so launch the confirmation dialog
    function startProjectConfirm(project) {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className="react-confirm-alert-body">
                        <h2>Start Project Confirmation </h2> <br/>
                        <p> Are you sure you want to start the project ? </p> <br/>
                        <div className="btn start-2">
                            <button
                                className="btn btn-primary start-5"
                                onClick={() => {
                                    goToProjectDetails(project);
                                    onClose();
                                }}
                            >
                                Yes
                            </button>
                            <button className="btn btn-primary start-5" onClick={onClose}>
                                No
                            </button>
                            {" "}
                        </div>
                    </div>
                );
            }
        });
    }

    //if user confirms Yes, goto single project details and update status to 'D'.
    async function goToProjectDetails(project) {
        const newAttributes = {
            projectStatus: "D",
        };

        const updatedProject = {
            ...project,
            ...newAttributes
        };
        let verifyProject = await getProject(updatedProject.id);
        if (verifyProject.projectStatus !== "U") {
            invalidDataConfirm();
            setRefreshProjects(true);
            return;
        }
        await updateProject(updatedProject);
        setActiveProject(updatedProject);
        setActiveDashboardTab("D");
        history.push(`/development/${project.id}/details`);
    }

    //this is a utility function which gets project objects for dup project ids
    function getDupProjects(dupIds) {
        let dupProjects = dupIds.map(dupIndex =>
            projects.filter(project => parseInt(project.id) === dupIndex)
        );
        let dupObjects = [];
        dupProjects.forEach(function (dupProject) {
            const dupProjectObject = dupProject[0];
            dupObjects.push(dupProjectObject);
        });
        return dupObjects;
    }

    //if duplicate projects exist, show merge popup
    function mergeProjectConfirm(project, dupProjects, dupIds) {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <MergeProject
                        context={context}
                        duplicateProjects={dupProjects}
                        project={project}
                        dupIds={dupIds}
                        handleClose={onClose}
                        handleMergeAccept={(projectM) => {
                            onClose();
                            history.push(`/development/${projectM.id}/details`);
                        }}
                        handleAccept={(project) => {
                            onClose();
                            history.push(`/development/${project.id}/details`);
                        }}
                    />
                );
            }
        });
    }

    return (
        <Fragment>
            <div style={{
                display: "flex",
                flexDirection: "row",
                flewGrow: 1,
                justifyContent: 'center',
                paddingRight: '16px',
                paddingBottom: '16px'
            }}>
                <div style={{flexGrow: 1}}/>
                <ViewType onViewTypeChange={onViewTypeChange} tabView={'upcoming'}/>
            </div>
            <div style={{zIndex: -1}}>
            {cardview === "cardview" ?
                <ProjectsGrid projects={projectList(projects)}
                              history={history}
                              context={context}
                              onButtonClick={startProject}
                              isLoading={isLoading}   
                              {...props} /> :
                <ProjectsList projects={projectList(projects)}
                              onButtonClick={startProject}
                              {...props}
                              />
            }
            </div>
        </Fragment>
    );
})
